import * as Entities from '../entities/index';

// Requests
export interface IEntityRequestModel {
  pageSize?: number;
  pageNumber?: number;
  orderBy?: string;
  orderAscending?: boolean;
  searchTerm?: string;
  filter?: string;
  filters?: string[];
  includes?: string[];
  searchTerms?: string[];
}

// Responses
export interface IResponseModel<T> {
  currentCount: number;
  filteredCount: number;
  maxCount: number;
  pageLength: number;
  pageNumber: number;
  results: T[];
  totalRecords: number;
}

export interface IEntityResponseModel<T> {
  pageLength: number;
  pageNumber: number;
  records: T[];
  totalRecords: number;
}

// Audit
export interface IAuditRequestModel extends IEntityRequestModel {
  entityId?: number;
  auditTypeId?: number;
}

//Call Center Phone Numbers
export interface ICallCenterPhoneNumberResponseFilterModel {
  filter: string;
}

// OrgLookups
export interface IOrgLookupRequestModel extends IEntityRequestModel {
  showOnlyAssignableOrglookups?: boolean;
  orgLookupId?: number;
}

export interface IOrgLookupByNameRequestModel extends IEntityRequestModel {
  regionName?: string;
  zoneName?: string;
  districtName?: string;
}

// Retailers
export interface IRetailerByNameRequestModel extends IEntityRequestModel {
  name: string;
}

export interface IRetailerByIdRequestModel extends IEntityRequestModel {
  retailerId: number;
}

export interface IRetailerByCodeRequestModel extends IEntityRequestModel {
  code: string;
}

export interface IRetailerRequestModel extends IEntityRequestModel {
  regionName?: string;
  zoneName?: string;
  orgLookupId?: number;
  isActive?: boolean;
  retailerId?: number;
}

export interface IRetailerUpdateModel {
  name: string;
  code: string;
  siteCode: string;
  address1: string;
  address2: string;
  city: string;
  stateCode: string;
  postCode: string;
  orgLookupId: number;
  latitude: number;
  longitude: number;
  primaryContactName: string;
  primaryContactEmail: string;
  primaryContactPhone: string;
  url: string;
  isActive: boolean;
}

// Retailer Note
export interface IRetailerNoteResponseModel {
  retailerNoteId: number;
  fullName: string;
  created: Date;
  content: string;
  type: string;
}

export interface IRetailerNotesResponseFilterModel {
  filter: string;
}

// Retailer Program
export interface IRetailerProgramsResponseFilterModel {
  filter: string;
}

export interface IRetailerProgramRequestModel {
  retailerPrograms: Entities.RetailerProgram[];
}

// Retailer Phone Numbers

export interface IRetailerPhoneNumbersResponseFilterModel {
  filter: string;
}

// Users
export interface IUserRequestModel extends IEntityRequestModel {
  showActiveOnly?: boolean;
  showVisibleOnly?: boolean;
  userName?: string;
  userId?: number;
}

export interface IUserRoleRequestModel {
  isAdmin: boolean;
  showOnlyVisibleRows: boolean;
}

export interface IUserUpdateModel {
  userName: string;
  firstName: string;
  lastName: string;
  active: boolean;
  roles: string[];
  isVisible: boolean;
  createDate: Date;
  userColor: string;
  imageUrl: string;
}

export interface IFilterModel {
  roleLevel?: string;
  roleEntity?: string;
  startDate: Date;
  endDate: Date;
  previousStartDate?: Date;
  previousEndDate?: Date;
  dispositionTypeId?: number;
  dispositions?: string;
}

export class ReportRequestModel {
  constructor(
    public reportType: string,
    public filters: IFilterModel,
    public orderBy?: string,
    public orderAscending: boolean = true
  ) {}
}

export interface ReportResponseModel<T> {
  reportType: string;
  pageLength: number;
  pageNumber: number;
  totalRecords: number;
  records: T[];
}

// eslint-disable-next-line @typescript-eslint/no-empty-object-type
export interface ReportRecord {}

export class Result<T> {
  constructor(
    public successful: boolean,
    public message: string,
    public data: T,
    public errors: ResultMessage[] = []
  ) {}

  public static success<T>(data: T): Result<T> {
    return new Result<T>(true, '', data);
  }

  public static error<T>(message: string): Result<T | null> {
    return new Result<T | null>(false, message, null);
  }
}

interface ResultMessage {
  Key: string;
  Message: string;
}
